import React from "react";
import "./blog.css";

const BlogPage = () => {
  return (
    <div className="blog-page">
      <div className="blog-hero">
        <div className="blog-hero-accent" />
        <div className="blog-hero-accent2" />
        <div className="blog-hero-inner">
          <span className="blog-hero-tag">Our Blog</span>
          <h1 className="blog-hero-title">
            Insights, Tips &amp;{" "}
            <span className="blog-hero-highlight">Stories</span>
          </h1>
          <p className="blog-hero-sub">
            Stay up to date with mobile billboard advertising news, success
            stories, and expert tips from the SignTruck team.
          </p>
        </div>
      </div>

      <div className="blog-body">
        <iframe
          src="https://app.trysoro.com/embed/e6eddced-dae6-4bd1-bf16-f4a60eb6e164"
          width="100%"
          height="1200px"
          frameBorder="0"
          title="SignTruck Blog"
          style={{ borderRadius: "10px", display: "block" }}
        />

        <div className="blog-cta">
          <h2 className="blog-cta-title">Ready to Get Your Brand Moving?</h2>
          <p className="blog-cta-text">
            Talk to our team about launching a mobile billboard campaign in
            Vancouver, Surrey, Burnaby, Langley, Cloverdale, and Chilliwack.
          </p>
          <a href="https://signtruck.ca/get-quote" className="blog-cta-btn">
            Get a Free Quote
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
